import { Component, DoCheck, Input, OnDestroy } from '@angular/core';
import { ProductDetailsUiStateService } from '../product-details-ui-state.service';
import { UserAnswer } from 'src/app/models/products/transactions';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionsService } from 'src/app/services/transactions.service';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ClientTransactionForm, ClientTransactionViewForm } from 'src/app/models/forms/transactions-form';

@Component({
  selector: 'app-product-details-step2',
  templateUrl: './product-details-step2.component.html',
  styleUrls: ['../online-product-details.component.scss']
})
export class ProductDetailsStep2Component implements DoCheck, OnDestroy {
  
  @Input() clientTransactionViewForm: FormGroup<ClientTransactionViewForm>;
  
  get clientTransactionForm(): AbstractControl<ClientTransactionForm> {
    return this.pUiService.clientTransactionForm;
  }

  renderFileUpload = true;
  fieldFocused = false;
  dropListener;
  constructor(
    public pUiService: ProductDetailsUiStateService,
    private _route: ActivatedRoute,
    private _transactionsService: TransactionsService,
    private _router: Router,
    ){

      this._addFileUploadListener();
  }
  


  private _addFileUploadListener(): void {
   document.addEventListener(
      "dragover",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
    this.dropListener = this._dropListener.bind(this);
    document.addEventListener(
      "drop",
      this.dropListener,
      true
    );

  }

  private _dropListener(e: DragEvent): void {
    e.preventDefault();
        e.stopPropagation();
        if ((<HTMLElement>e.target)?.classList.contains("can-droped-area")) {
          this._dropFiles(e);
        }
  }

 private _dropFiles(event: DragEvent): void {
    this.pUiService.uploadFiles(event.dataTransfer.files);
  }

  ngDoCheck(): void {
    const trnsIndex = this._route.snapshot.params.i;
    if (trnsIndex && this.pUiService.files == null && this._transactionsService.fileList.data.items.length > 0) {
      this.pUiService.files = this._transactionsService.fileList.data.items[trnsIndex];
    }
  
  }

  userAnswerChange(answers: Array<UserAnswer>): void {
    this.pUiService.userAnswers = answers;
  }

  upload(event): void {
    this.pUiService.uploadFiles(event.target.files);
  }

  


  fieldFocus(): void {
    document.querySelector('.ask-us-btn')?.classList.add('ask-us-btn-top');
    this.fieldFocused = true;
  }

  fieldBlur(): void {
    document.querySelector('.ask-us-btn')?.classList.remove('ask-us-btn-top');
    this.fieldFocused = false;
  }

  selectFile(): void {
    (document.querySelector('#file-list') as HTMLDivElement).click();
  }

  removeFile(fileIndex): void {
    const newFileList = [];
    const newFileBase64 = [];
    for (let i = 0; i < this.pUiService.files.length; i++) {
      if (i !== fileIndex) {
        newFileList.push(this.pUiService.files[i]);
        newFileBase64.push(this.pUiService.filesSrcBase64[i]);
      }
    }
    this.pUiService.files = newFileList;
    this.pUiService.filesSrcBase64 = newFileBase64;
    this.renderFileUpload = false;
    window.setTimeout(() => {
      this.renderFileUpload = true;
    }, 500);
  }

  navToProductList(): void {
    if (this.pUiService.checkValidity()) {
      this.pUiService.addProductToBasket(this._route.snapshot.params.i);
      this._router.navigate(['/archonline_product_list']);
    }
  }

  GoToBasket(): void{
    this.pUiService.GoToBasket(this._route.snapshot.params.i);
  }

  ngOnDestroy(): void {
    document.removeEventListener("drop", this.dropListener, true);
   }
}
